/*
 * Modal Routed Component
 */
(function() {
  'use strict';

  angular
    .module('tyallsApp')
    .config(['$stateProvider', function($stateProvider) {
      $stateProvider 
        .state('app.prop.prop-admin.user-console.list-user.add-property-profile-dialog', {
          // url: '',  // modal -- no url
          params: { 
            user: null,
            propertyId: null,
            onSuccessfulEdit: null,
          }, // non-url params
          data: {
            authorities: []
          },
          resolve: {
            user: ['$transition$', function($transition$) {
              return $transition$.params().user;
            }],
            propertyId: ['$transition$', function($transition$) {
              return $transition$.params().propertyId;
            }],
            onSuccessfulEdit: ['$transition$', function($transition$) {
              return $transition$.params().onSuccessfulEdit;
            }]
          },
          onEnter: ['$filter', 'onSuccessfulEdit', 'user', 'propertyId', '$state', '$uibModal', function($filter, onSuccessfulEdit, user, propertyId, $state, $uibModal) {
            $uibModal.open({
              templateUrl: 'app/entities/prop-admin/user-console/dialogs/add-property-profile/add-property-profile-dialog.html',
              controller: 'AddPropertyProfileDialogController',
              controllerAs: '$ctrl',
              backdrop: 'static',
              size: 'md',
              resolve: {
                availablePropertyProfiles: [ 'PropertyProfileService', function(PropertyProfileService) {
                  return PropertyProfileService.getWithPropertyId(propertyId)
                    .then(function(response) {
                      return $filter('removeUnassignableProfiles')(response.data);
                    });
                }],
                user: { value: user },
                onSuccessfulEdit: { value: onSuccessfulEdit },
              }
            }).result.then(function(response) {
              $state.go('^');
            }, function(reason) {
              $state.go('^');
            });
          }]
        });

    }]);

})();
